<template>
  <button
    type="button"
    class="favourite-toggle"
    :class="{ 'favourite-toggle--active': isFavourite }"
    :disabled="busy || !canSaveFavourites"
    v-b-tooltip.hover="tooltipTitle"
    @click.stop="onClick"
  >
    <b-icon :icon="isFavourite ? 'star-fill' : 'star'" />
  </button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FavouriteToggle',

  props: {
    tradieId: {
      type: [Number, String],
      required: true,
    },
    // Full candidate object, when the parent already has one in memory (e.g.
    // CandidateCard). Used as a client-side fallback so the Favourites list
    // shows real data immediately on toggle, instead of whatever minimal
    // shape the API's add/remove response happens to return.
    candidate: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      busy: false,
    }
  },

  computed: {
    ...mapGetters('auth', ['hasPermission']),

    isFavourite() {
      return this.$store.getters['candidate/isFavourite'](this.tradieId)
    },

    canSaveFavourites() {
      return this.hasPermission('candidates.save_favourites')
    },

    tooltipTitle() {
      if (!this.canSaveFavourites) return { title: '', disabled: true }
      return {
        title: this.isFavourite
          ? 'Remove from favourites'
          : 'Save to favourites',
        disabled: false,
      }
    },
  },

  methods: {
    ...mapActions('candidate', ['toggleFavourite']),

    async onClick() {
      if (this.busy || !this.canSaveFavourites) return
      this.busy = true
      try {
        await this.toggleFavourite({
          tradieId: this.tradieId,
          candidate: this.candidate,
        })
        this.$emit('toggled', !this.isFavourite)
      } catch (err) {
        this.$emit('error', err)
      } finally {
        this.busy = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.favourite-toggle {
  background: none;
  border: none;
  padding: 0.25rem;
  line-height: 1;
  color: #b8bcc6;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &--active {
    color: #ffc107;
  }
}
</style>
